export default __webpack_public_path__ + "static/BrandonGrotesque-Black-8d7299cfb9278c9e8c7d0638dbacb6de.woff2";